import React from "react";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Madde Kayıt brand mark — hexagonal molecule with subtle bond.
 * Pure SVG, scales with size prop. Uses currentColor for accent so it
 * can be tinted by parent text color when needed.
 */
const Logo = ({ size = 36, withText = true, className = "" }) => {
  const { t } = useLanguage();
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Madde Kayıt"
      >
        <defs>
          <linearGradient id="mk-grad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#0D9488" />
            <stop offset="100%" stopColor="#0F766E" />
          </linearGradient>
        </defs>
        {/* outer hexagon */}
        <polygon
          points="32,4 56,18 56,46 32,60 8,46 8,18"
          stroke="url(#mk-grad)"
          strokeWidth="2.5"
          fill="white"
        />
        {/* inner hex */}
        <polygon
          points="32,16 46,24 46,40 32,48 18,40 18,24"
          stroke="#0D9488"
          strokeOpacity="0.45"
          strokeWidth="1.2"
          fill="#F0FDFA"
        />
        {/* bond line */}
        <line x1="18" y1="24" x2="46" y2="40" stroke="#0F766E" strokeWidth="2" strokeLinecap="round" />
        {/* atoms */}
        <circle cx="18" cy="24" r="3.4" fill="#0D9488" />
        <circle cx="46" cy="40" r="3.4" fill="#0F766E" />
        <circle cx="32" cy="32" r="2.2" fill="#0F172A" />
      </svg>

      {withText && (
        <div className="leading-none">
          <div
            className="font-display text-[19px] tracking-tight text-slate-900"
            style={{ fontWeight: 600 }}
          >
            Madde Kayıt
          </div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-teal-700/80 mt-0.5">
            {t("logo.tagline")}
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
